export const CFDI_THREE_VERSION = '3.3';
export const CFDI_FOUR_VERSION = '4.0';

export const cfdiCancelKey = [
  'invoice.cdfi_not_found_on_sat.error',
  'credit-notes.cdfi_not_found_on_sat.error',
  'payments.cdfi_not_found_on_sat.error'
]


// WEBPACK FOOTER //
// ./src/constants/cfdi.js